import React from 'react';
import { useMediaQuery } from 'react-responsive';
import AboutContent from './AboutContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <AboutContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
